/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Icon from "../common/Icon.vue";
import appConfig from "../../api/appConfig";
import SimpleBar from "simplebar";
import $ from 'jquery';

const Event = {
  SCROLL: "scroll.cl.listmenu",
};

const ClassName = {
  DISABLED: "t-disabled",
};

const __vue_script__ = {
  name: "ListMenu",
  components: {
    Icon,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    hasArrows: {
      type: Boolean,
      default: false,
    },
    menuType: {
      type: String,
      default: "",
    },
    scrollToCurrent: {
      type: Number,
      default: null,
    },
  },
  data: function() {
    return {
      scrollPosition: {
        top: true,
        bottom: false,
      },
    };
  },
  watch: {
    items() {
      this.resetScroll();
    },
    scrollToCurrent(newShopId) {
      this.scrollToItem(newShopId);
      this.$store.dispatch("disableAutoScrollToCurrent");
    },
  },
  created() {
    // these vars are not in the data() because, they are not reactive
    this.vars = {
      simpleBar: null,
      $scrollContent: null,
    };
  },
  mounted() {
    this.$nextTick(function() {
      const _self = this;
      _self.vars.simpleBar = new SimpleBar(
        $(this.$el).find(".listMenu_listContainer")[0]
      );
      _self.vars.$scrollContent = $(this.$el).find(".simplebar-scroll-content");

      _self.vars.$scrollContent.on(Event.SCROLL, function() {
        _self.updateScrollPositionData(_self.vars.$scrollContent);
      });
    });
  },
  updated() {
    this.updateScrollPositionData(this.vars.$scrollContent);
  },
  beforeDestroyed() {
    this.vars.$scrollContent.off(Event.SCROLL);

    if (this.vars.simpleBar) {
      this.vars.simpleBar.removeObserver();
    }
  },
  methods: {
    scrollUp: function() {
      $(this.$el)
        .find(".simplebar-scroll-content")
        .scrollTo("-=" + appConfig.scrollStep, appConfig.scrollSpeed);
    },
    scrollDown: function() {
      $(this.$el)
        .find(".simplebar-scroll-content")
        .scrollTo("+=" + appConfig.scrollStep, appConfig.scrollSpeed);
    },
    resetScroll: function() {
      $(this.$el)
        .find(".simplebar-scroll-content")
        .scrollTo(0);
    },
    scrollToItem: function(id) {
      $(this.$el)
        .find(".simplebar-scroll-content")
        .scrollTo(
          $(this.$el).find("[data-id=" + id + "]"),
          appConfig.autoScrollSpeed
        );
    },
    updateScrollPositionData: function($scrollContent, scrollPosition) {
      const _self = this;
      const scrollTop = $scrollContent.scrollTop();
      if (scrollPosition) {
        _self.scrollPosition.bottom = scrollPosition.bottom;
        _self.scrollPosition.top = scrollPosition.top;
      } else {
        if (
          scrollTop >=
          $scrollContent.find(".simplebar-content").innerHeight() -
            $scrollContent.innerHeight()
        ) {
          _self.scrollPosition.bottom = true;
        } else {
          _self.scrollPosition.bottom = false;
        }
        if (scrollTop < 5) {
          _self.scrollPosition.top = true;
        } else {
          _self.scrollPosition.top = false;
        }
      }
    },
  },
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "listMenu",
      class: { "listMenu-withArrows": _vm.hasArrows },
    },
    [
      _c("div", { staticClass: "listMenu_header" }, [_vm._t("header")], 2),
      _vm._v(" "),
      _c("div", { staticClass: "listMenu_listContainer" }, [
        _c(
          "ul",
          { staticClass: "listMenu_list" },
          [
            _vm.$slots["notice"]
              ? _c(
                  "li",
                  { staticClass: "listMenu_item listMenu_item-notice" },
                  [_vm._t("notice")],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.items, function (item) {
              return _c(
                "li",
                {
                  key: item.id,
                  staticClass: "listMenu_item",
                  attrs: { "data-id": item.id },
                },
                [_vm._t("itemContent", null, null, item)],
                2
              )
            }),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "listMenu_scrollNav" }, [
        _c("div", { staticClass: "scrollNav" }, [
          _c(
            "button",
            {
              staticClass: "scrollNav_button scrollNav_button-top",
              class: [{ "t-disabled": _vm.scrollPosition.top }],
              on: { click: _vm.scrollUp },
            },
            [
              _c(
                "div",
                { staticClass: "scrollNav_icon" },
                [_c("Icon", { attrs: { "icon-name": "arrow-right" } })],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "scrollNav_button scrollNav_button-bottom",
              class: [{ "t-disabled": _vm.scrollPosition.bottom }],
              on: { click: _vm.scrollDown },
            },
            [
              _c(
                "div",
                { staticClass: "scrollNav_icon" },
                [_c("Icon", { attrs: { "icon-name": "arrow-right" } })],
                1
              ),
            ]
          ),
        ]),
      ]),
    ]
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "resources/kiosk/scripts/components/listmenus/ListMenu.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__